import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mb-25" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_4 = { class: "card card-prelogin border-0 rounded-0 bg-white authentication-card" }
const _hoisted_5 = { class: "card-body letter-spacing" }
const _hoisted_6 = { class: "fw-bold mb-0" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = { class: "password-input" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between mb-15 mb-md-20" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_17 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('feature.auth.$login.title')), 1 /* TEXT */),
            _createElementVNode("form", {
              id: "login-form",
              onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  title: "Email",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.usernameIsValid }]]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                  placeholder: _ctx.$t('form.email.placeholder'),
                  required: "",
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+"
                }, null, 10 /* CLASS, PROPS */, _hoisted_9), [
                  [_vModelText, _ctx.username]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('form.password.label')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    title: "Password",
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.passwordIsValid }]]),
                    required: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    placeholder: _ctx.$t('form.password.placeholder')
                  }, null, 10 /* CLASS, PROPS */, _hoisted_13), [
                    [_vModelText, _ctx.password]
                  ]),
                  _createElementVNode("i", {
                    class: "ph ph-eye position-absolute top-0 end-0 fs-18 text-muted",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePassword($event)))
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createCommentVNode(" <div class=\"form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1\">\n                  <input class=\"form-check-input shadow-none\" type=\"checkbox\" id=\"remember-me\" />\n                  <label class=\"form-check-label\" for=\"remember-me\">\n                    Remember Me\n                  </label>\n                </div> "),
                _createVNode(_component_router_link, {
                  to: "/forgot-password",
                  class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('feature.auth.forgot_password')) + "? ", 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, {
                  to: "/request-support",
                  class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('feature.auth.request_support')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100",
                    type: "submit",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setPristine && _ctx.setPristine(...args)))
                  }, _toDisplayString(_ctx.$t('cta.login')), 1 /* TEXT */))
                : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 })),
              _createCommentVNode(" <span\n        class=\"d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16\"\n        >\n        Don’t have an account?\n      </span>\n      <router-link\n      to=\"/register\"\n      class=\"default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center\"\n      >\n      Create Account\n    </router-link>\n    <span\n    class=\"d-block or text-muted text-center mt-15 mb-15 mt-md-20 mb-md-20 fs-md-15 fs-lg-16 position-relative z-1 lh-1\"\n    >\n    <span class=\"d-inline-block bg-white\">Or</span>\n  </span>\n  <ul class=\"socials ps-0 mb-0 list-unstyled text-center\">\n    <li class=\"d-inline-block\">\n      <button\n      type=\"button\"\n      class=\"d-block rounded-circle text-center position-relative facebook border-0 p-0\"\n      >\n      <i class=\"ph-fill ph-facebook-logo\"></i>\n    </button>\n  </li>\n  <li class=\"d-inline-block\">\n    <button\n    type=\"button\"\n    class=\"d-block rounded-circle text-center position-relative google border-0 p-0\"\n    >\n    <i class=\"ph-bold ph-google-logo\"></i>\n  </button>\n</li>\n<li class=\"d-inline-block\">\n  <button\n  type=\"button\"\n  class=\"d-block rounded-circle text-center position-relative twitter border-0 p-0\"\n  >\n  <i class=\"ph-fill ph-twitter-logo\"></i>\n</button>\n</li>\n<li class=\"d-inline-block\">\n  <button\n  type=\"button\"\n  class=\"d-block rounded-circle text-center position-relative linkedin border-0 p-0\"\n  >\n  <i class=\"ph-fill ph-linkedin-logo\"></i>\n</button>\n</li>\n</ul> ")
            ], 32 /* NEED_HYDRATION */)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ])
  ]))
}